// react-router components
import { Routes, Route } from "react-router-dom";

import { Auth0Provider } from "@auth0/auth0-react";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import Home from "./pages/Home";
import Login from "./pages/Login";
import Logout from "./pages/Logout";
import RemoteAction from "./pages/RemoteAction";
import LoginGuard from "./pages/LoginGuard";
import ServiceSingle from "./pages/service/single";
import Dashboard from "./pages/dashboard";
import PrescriberPatients from "./pages/prescribers/patients";
import Profile from "./pages/profile";
import Prescribers from "./pages/prescribers";
import Prescriber from "./pages/prescribers/single";
import AddPrescriber from "./pages/prescribers/new";
import Enroll from "./pages/prescribers/enroll";
import PagePatients from "./pages/patients/PagePatients";
import Patient from "./pages/patients/single";
import Service from "./pages/service";
import Inventory from "./pages/inventory";
import InventoryType from "./pages/inventory/single";
import PatientAction from "./pages/patients/action";

import theme from "./assets/theme";
import PageNotFound from "./pages/PageNotFound";
import PagePatientNew from "./pages/patients/PagePatientNew";
import PageIntake from "./pages/intake/PageIntake";

function App() {
  return (
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      redirectUri={process.env.REACT_APP_AUTH0_REDIRECT_URL}
      audience={process.env.REACT_APP_AUTH0_AUDIENCE}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Routes>
          <Route element={<LoginGuard />}>
            <Route path="/profile" element={<Profile />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/prescribers" element={<Prescribers />} />
            <Route path="/prescribers/new" element={<AddPrescriber />} />
            <Route
              path="/prescribers/:npi/enroll/:program"
              element={<Enroll />}
            />
            <Route
              path="/prescribers/:npi/patients"
              element={<PrescriberPatients />}
            />
            <Route
              path="/prescribers/:npi/patients-new"
              element={<PagePatientNew />}
            />
            <Route path="/prescribers/:npi" element={<Prescriber />} />
            <Route path="/patients" element={<PagePatients />} />
            <Route
              path="/patients/:id/actions/:action"
              element={<PatientAction />}
            />
            <Route path="/patients/:id" element={<Patient />} />
            <Route path="/intake/:id" element={<PageIntake />} />
            <Route path="/service" element={<Service />} />
            <Route path="/service/:id" element={<ServiceSingle />} />
            <Route path="/inventory" element={<Inventory />} />
            <Route path="/inventory/:id" element={<InventoryType />} />
          </Route>

          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/sign/:id" element={<RemoteAction />} />

          {/*build 404*/}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </ThemeProvider>
    </Auth0Provider>
  );
}

export default App;
